import React from 'react';
import { FaExternalLinkAlt, FaGlobeAsia, FaMusic } from 'react-icons/fa';
import Cherry from '../Assets/Cherry.png';
import Mountain from '../Assets/JustMountain.png';
import Sky from '../Assets/Sky.png';
import Logo from '../Assets/JapanLogo.png';

const PROGRAM_LINKS = [
  {
    label: '日本語で見る',
    helper: 'Japanese Music Program / 日本語プログラム',
    url: 'https://canva.link/simanof-japan',
    accent: 'bg-red-600 hover:bg-red-700 focus:ring-red-300',
  },
  {
    label: 'View in English',
    helper: 'English Music Program / 英語プログラム',
    url: 'https://canva.link/simanofjapan',
    accent: 'bg-slate-900 hover:bg-black focus:ring-slate-300',
  },
];

export default function MusicProgramLinks() {
  return (
    <main className="relative min-h-screen overflow-hidden bg-[#f7fbff] text-slate-950">
      <img src={Sky} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <img src={Mountain} alt="" className="absolute bottom-0 left-0 w-full object-cover" />
      <div className="absolute inset-0 bg-white/45" />

      <img
        src={Cherry}
        alt=""
        className="absolute right-[-24px] top-8 w-28 rotate-12 opacity-80 sm:right-8 sm:w-36"
      />
      <img
        src={Cherry}
        alt=""
        className="absolute bottom-28 left-[-28px] w-24 -rotate-12 opacity-70 sm:left-10 sm:w-32"
      />

      <section className="relative z-10 mx-auto flex min-h-screen max-w-xl flex-col items-center justify-center px-6 py-12 text-center">
        <img src={Logo} alt="Simanof Japan Tour" className="mb-8 h-20 w-auto drop-shadow-md" />

        <div className="mb-8 inline-flex items-center gap-2 rounded-full border border-red-200 bg-white/80 px-4 py-2 text-sm font-semibold text-red-700 shadow-sm backdrop-blur">
          <FaMusic />
          Simanof Japan Tour
        </div>

        <h1 className="text-4xl font-black leading-tight text-slate-950 sm:text-5xl">
          Music Program
          <span className="mt-2 block text-3xl sm:text-4xl">音楽プログラム</span>
        </h1>
        <p className="mt-4 max-w-md text-base font-medium leading-7 text-slate-700 sm:text-lg">
          Please choose your language.
          <span className="block">ご希望の言語を選んでください。</span>
        </p>

        <div className="mt-10 grid w-full gap-4">
          {PROGRAM_LINKS.map((program) => (
            <a
              key={program.url}
              href={program.url}
              target="_blank"
              rel="noreferrer"
              className={`group flex min-h-24 items-center justify-between rounded-2xl px-6 py-5 text-left text-white shadow-xl shadow-slate-900/15 transition duration-200 ${program.accent} focus:outline-none focus:ring-4`}
            >
              <span>
                <span className="block text-xl font-extrabold">{program.label}</span>
                <span className="mt-1 block text-sm font-semibold text-white/80">{program.helper}</span>
              </span>
              <span className="ml-4 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-white/20 transition group-hover:bg-white/30">
                <FaExternalLinkAlt />
              </span>
            </a>
          ))}
        </div>

        <div className="mt-8 flex items-center gap-2 text-sm font-semibold text-slate-600">
          <FaGlobeAsia className="text-red-600" />
          Scan and choose. / スキャンして選択してください。
        </div>
      </section>
    </main>
  );
}
